
import ErrorService from '@/utils/ErrorService';
import { downloadFile } from '@/utils/FilesDownloading';
import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class Download extends Vue {
    async mounted() {
        const id = this.$route.params.id;
        /**
         * type is PMPlanChartEnum
         */
        const type = this.$route.params.type;
        const url = `/project-management/${type}/${id}/excel`;
        const fileName = 'file.xlsx';
        try {
            const fileData = {
                url,
                name: fileName,
            };

            await downloadFile(fileData).then(() => {
                this.$router.replace('/');
            });
        } catch (error) {
            ErrorService.handleApiError(error);
        }
    }
}
